import ReadMoreDocsLink from "components/ReadMoreDocsLink";
import Callout from "ds/components/Callout";
import FeedbackActions from "ds/components/Feedback/Actions";
import useTypedContext from "hooks/useTypedContext";
import { AuthorizationScheme } from "types/generated";
import { getDocsUrl } from "utils/getDocsUrl";
import { SpacesContext } from "views/Account/SpacesProvider";

const STORAGE_KEY = "spaceDetailsLoginPolicyCalloutClosed";

const SpaceDetailsLoginPolicyCallout = () => {
  const { authorizationScheme } = useTypedContext(SpacesContext);

  if (authorizationScheme !== AuthorizationScheme.LoginPolicies) {
    return null;
  }

  return (
    <Callout variant="warning" title="Managed by login policies" storageKey={STORAGE_KEY}>
      This account uses login policies: access for users, IdP groups, and API keys is granted at
      login, so it doesn't appear here. To see and manage space access on this page, switch your
      management strategy to Identity Access Management.{` `}
      <FeedbackActions>
        <ReadMoreDocsLink
          docsUrl={getDocsUrl("/concepts/identity-access-management.html")}
          title="Learn more about Identity Access Management"
        />
      </FeedbackActions>
    </Callout>
  );
};

export default SpaceDetailsLoginPolicyCallout;
